import { computed, ref, watch } from 'vue';
import { defineStore } from 'pinia';
import {
  pushRecentSearch,
  readRecentSearches,
  writeRecentSearches,
  type RecentSearch,
} from '@/libs/helpers/recent-searches';
import { useGroupStore } from './group';

/** Search results the passenger opened, per network, most recent first. */
export const useRecentSearchesStore = defineStore('recentSearches', () => {
  const groupStore = useGroupStore();

  const groupId = computed<string | undefined>(() => groupStore.group?.group_id);
  const items = ref<RecentSearch[]>([]);

  watch(
    groupId,
    id => {
      items.value = id ? readRecentSearches(id) : [];
    },
    { immediate: true },
  );

  function persist() {
    if (groupId.value) writeRecentSearches(groupId.value, items.value);
  }

  function add(entry: RecentSearch) {
    items.value = pushRecentSearch(items.value, entry);
    persist();
  }

  /** Drops the entries the current GTFS no longer knows (removed stop or line). */
  function prune(isKnown: (entry: RecentSearch) => boolean) {
    const kept = items.value.filter(isKnown);
    if (kept.length === items.value.length) return;
    items.value = kept;
    persist();
  }

  return { items, add, prune };
});
